<template>
    <div class="action-buttons">
        <v-btn color="gray" dark medium>
            {{ $t('marketplace.products.addProduct') }}
        </v-btn>
        <v-btn color="primary" dark medium @click="redirectToProducts">
            {{ $t('marketplace.common.products') }}
        </v-btn>
    </div>
</template>
<script>
export default {
    methods: {
        redirectToProducts() {
            this.$router.push({
                name: 'marketplaceProducts'
            });
        }
    }
}
</script>

<style scoped>
.action-buttons {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
}

@media (max-width: 600px) {
    .action-buttons {
        width: 100%;
        justify-content: stretch;
    }

    .action-buttons .v-btn {
        flex: 1 1 calc(50% - 4px);
        min-width: 0;
        margin: 0 !important;
    }
}
</style>
